export default function DeviceTypeCheck() {
  const agent = navigator.userAgent.toLocaleLowerCase();

  if (agent.includes("iphone")) {
    return "iphone";
  } else {
    return "android";
  }
}
